import React from 'react'
import { useForm } from 'react-hook-form'
import { IconMail } from '@tabler/icons-react'
import { useAuth } from '../../../Auth/AuthProvider'
import { Link } from 'react-router-dom'
import Spinner from '../../../Components/Spinner'

const fieldClass =
  'w-full border border-mauve-200 bg-white px-3 py-2 text-mauve-900 outline-none transition focus:border-mauve-500'

export default function ForgotPasswordForm(props) {
  const { register, handleSubmit } = useForm()
  const { resetPassword } = useAuth()

  const sendReset = ({ loginEmail }) => {
    props.handleLogin('email', true)
    resetPassword(loginEmail)
      .then(() => {
        props.handleLogin('email', false)
        props.handleError('email', 'Password reset email sent. Check your inbox.')
      })
      .catch((err) => {
        props.handleLogin('email', false)
        props.handleError('email', err.message)
      })
  }

  return (
    <form onSubmit={handleSubmit(sendReset)} className="space-y-3">
      <input {...register('loginEmail')} className={fieldClass} placeholder="Email" type="email" defaultValue="" />
      {props.error ? <p className="text-sm text-red-600">{props.error}</p> : null}
      <button
        type="submit"
        className="flex w-full items-center justify-center gap-2 bg-mauve-800 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-mauve-900"
      >
        {props.loggingIn ? (
          <Spinner className="text-white" />
        ) : (
          <>
            <IconMail className="size-4" />
            Send reset email
          </>
        )}
      </button>
      <p className="text-sm italic text-mauve-500">
        Remembered it?{' '}
        <Link to="/login" className="text-mauve-700 not-italic hover:text-mauve-900">
          Sign in
        </Link>
      </p>
    </form>
  )
}
